import Footer from '../Footer'
import Header from '../Header'
import React from 'react'
import { Outlet } from 'react-router-dom'
import ChatWrapper from '../view/Component/ChatWrapper'

function SubLayout() {
    return (
        <div className='ar_mainBody'>
            <Header />
            <div className='sub-layout-child'>
                <Outlet />
            </div>
            <ChatWrapper />
            <Footer />
        </div>
    )
}

export default SubLayout
